import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { APIs } from '../config/api.constant';
import { AppConstant } from '../config/app.constant';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class FaqService {
  editFaqDetails: { id: number; answer: string; question: string } = null;
  token: string;
  isPopup = new BehaviorSubject<boolean>(false);

  constructor(private apiService: ApiService) {}

  triggerPopup(status: boolean): void {
    console.log("inside trigger popup")
    this.isPopup.next(status);
  }

  getPopupStatus(): Observable<boolean> {
    return this.isPopup.asObservable();
  }

  getFaqs(): Observable<any> {
    return this.apiService.get(APIs.getFaq).pipe(
      map((response) => {
        return response.list;
      })
    );
  }

  saveFaq(data,param = '') {
    return this.apiService.post(APIs.saveFaq+param, data).pipe(
      map((response) => {
        return response;
      })
    );
  }

  deleteFaq(data) {

    return this.apiService.put(APIs.deleteFaq+`?id=${data}`).pipe(
      map((response) => {
        return response;
      })
    );
  }

  getFaqByid(id) {
    return this.apiService.get(APIs.getFaqById+ '?id='+id).pipe(
      map((response) => {
        return response.data[0];
      })
    );
  }

  // FaqDetail(data){
  //   return this.apiService.get(APIs.editFaq, data).pipe(map(response => {
  //     return response;
  //   }))
  // }

  setEditFaqDetails(data) {
    this.editFaqDetails = data;
  }

  getEditFaqDetials() {
    return this.editFaqDetails;
  }




}
